import { InteractionRequiredAuthError } from "@azure/msal-browser"
import { callApiWithAuthorization } from "../../API/CallApi";
import { loginRequest } from '../../Auth/AuthConfig'

export async function getToken() {
    let tokenRequest = await callApiWithAuthorization("/api/v0/getOrder", {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    })
    let token = await tokenRequest.json()
    return token.access_token
}

export async function getAccessToken(context) {
    const accessTokenRequest = {
        scopes: loginRequest.scopes,
        account: context.accounts[0]
    }
    try {
        let accessTokenResponse = await context.instance.acquireTokenSilent(accessTokenRequest)
        return accessTokenResponse.accessToken
    } catch (error) {
        if (error instanceof InteractionRequiredAuthError) {
            alert("Token Expired wait untill we validate")
            try {
                let accessTokenResponse = await context.instance.acquireTokenPopup(accessTokenRequest)
                return accessTokenResponse.accessToken
            } catch (error) {
                return ("Access Token Error")
            }
        }
    }
}

export async function checkAccessToken(context) {
    const accessTokenRequest = {
        scopes: loginRequest.scopes,
        account: context.accounts[0]
    }
    try {
        await context.instance.acquireTokenSilent(accessTokenRequest)
        return true
    } catch (error) {
        return false
    }
}

export function getAccessTokenFromLocalStorage() {
    for (const key in localStorage) {
        const value = localStorage.getItem(key);
        if (value) {
            const jsonValue = JSON.parse(value);
            if (
                jsonValue &&
                typeof jsonValue === "object" &&
                jsonValue["credentialType"] === "AccessToken"
            ) {
                return jsonValue["secret"];
            }
        }
    }
    return null;
}